export default "__VITE_ASSET__Cwi02wXI__"